export var ACTION_FREE_TRIAL_SIGNUP = 'ft/signup';
export var ACTION_USER_EXISTS = 'user/exists';
export var ACTION_WAITLIST_SIGNUP = 'waitlist/signup';
export var ACTION_WAITLIST_QUESTIONNAIRE = 'waitlist/questionnaire';
export var ACTION_CONTACT_FORM_SUBMISSION = 'contact/form';
export var ACTION_FAQ_QUESTION_FORM_SUBMISSION = 'faq/form';
export var ACTION_EMPLOYERS_FORM_SUBMISSION = 'employers/form';
export var ACTION_EMPLOYERS_WHITE_PAPER_SUBMISSION = 'employers/white-paper';
export var ACTION_CREATE_LEAD = 'checkout/plan';